/**
 * Parse the `?from=<id>` wizard query param into a valid source campaign id, or
 * null when absent/invalid (FIR-7659). Carrying the source in the URL is what
 * lets the "create from existing" prefill survive a reload — see
 * sequence-wizard-page-v2.tsx, which seeds `sequenceSourceMode` from this.
 *
 * Returns null for: missing param, non-numeric / non-integer / non-positive
 * values, and self-reference (a campaign cannot copy from itself).
 */
export function sequenceSourceFromParam(
  rawFrom: string | null | undefined,
  currentCampaignId: number
): number | null {
  if (rawFrom == null || rawFrom === '') return null
  const parsed = Number(rawFrom)
  if (!Number.isInteger(parsed) || parsed <= 0) return null
  if (parsed === currentCampaignId) return null
  return parsed
}
